export const PROCUREMENTS_VIEWS = ['list', 'board'] as const;

export const SUBCONTRACTOR_OFFER_TYPE = 90;
